// extracted by mini-css-extract-plugin
export default {"app":"App_app__KwO8K","appScrollHidden":"App_appScrollHidden__Kj8vz"};